import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/lvyun-theme.css'
import api from './api/client'
import { initAuthActivityTracking } from './utils/auth'

Vue.use(ElementUI)

// 接口基址见 api/client.js（默认当前站点 /api；可设 VUE_APP_API_BASE 指向远程或本机 Node）
Vue.prototype.$api = api

Vue.config.productionTip = false
initAuthActivityTracking()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')